import { AuthService } from 'src/app/Service/AuthService';

import { UserService } from 'src/app/Service/UserService';
import { BasePanelController } from '../../../../../BaseUI/BasePanelController';
import { SocialLinkSettingPanelComponent } from './SocialLinkSettingPanelComponent';
import {StorageService} from '../../../../../../Service/StorageService';


export class SocialLinkSettingPanelController extends BasePanelController {
	public combineView: SocialLinkSettingPanelComponent;

	/**
	 * getLineLinkStatus
	 * Lineとの連携状態を取得する
	 * true: 連携状態 false: 未連携
	 * @param param viewインスタンス
	 * @returns true: 連携済み/false: 未連携
	 */
	public async getLineLinkStatus(param: {view: any}) {

		const svc = new UserService(param.view);
		const ret = await svc.getLineLinkStatus();

		return ret;

	}

	/**
	 * unlinkSocialLink
	 * Lineとの接続を解除する
	 * @param param viewインスタンス
	 */
	public async unlinkSocialLink(param: { view: any }) {

		const svc = new UserService(param.view);
		const ret = await svc.unlinkLineLink();

		return ret;

	}
	/**
	 * stateを生成
	 * @returns string
	 */
	public async getState() {
		return this.generateRandomId(32);
	}
	/**
	 * nonceを生成
	 * @returns string
	 */
	public async getNonce() {
		return this.generateRandomId(8);
	}

	/**
	 * 認可リクエスト記録
	 */
	public async recordAuth(loginUrl: string, stateString: string, nonceString: string) {
		const svc = new AuthService(this);
		return await svc.lineLoginRecordAuth(loginUrl, stateString, nonceString);
	}

	/**
	 * ブラウザにstateとnonceを保存
	 */
	public async setStateNonce(param: { stateString: string; nonceString: string }) {
		const svc = new StorageService(this);
		await svc.saveItem('state', param.stateString);
		await svc.saveItem('nonce', param.nonceString);
		return;
	}

	/**
	 * ランダム文字生成
	 * @returns string
	 * @param length
	 */
	private generateRandomId(length: number): string {
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let result = '';

		for (let i = 0; i < length; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			result += characters.charAt(randomIndex);
		}
		return result;
	};

	/**
	 * getConfigForClient
	 * Lineログインの設定情報を取得
	 * @returns any
	 */
	public getConfigForClient() {
		const svc = new AuthService(this);
		return svc.getConfigForClient();
	}

}
